import { Separator } from '@/lib/components/ui/separator';
import Header from '../components/Header';
import ProgressStep, { ProgressStepProps } from '../components/ProgressStep';

type StepTemplateProps = {
  title?: string;
  subTitle?: string;
  step?: ProgressStepProps['step'];
  children: React.ReactNode;
  footer?: React.ReactNode;
};

const StepTemplate = ({
  title,
  subTitle,
  step,
  children,
  footer = null,
}: StepTemplateProps) => {
  return (
    <>
      <div className="flex flex-col grow px-4 pb-4 sm:px-12 sm:pt-4 sm:pb-8 md:px-18">
        {step && <ProgressStep step={step} />}
        {title && <Header title={title} subTitle={subTitle} />}
        {children}
      </div>

      {footer && (
        <div className="flex flex-col items-center">
          <Separator />
          <div className="pt-4 sm:pt-8">{footer}</div>
        </div>
      )}
    </>
  );
};

export default StepTemplate;
